import React, { createContext, useContext } from 'react';

/**
 * Fallback hire bar (0–100, the Interview Report scale) for scores outside any batch.
 * Each batch has its own bar (batch.min_hire_score); results carry it as r.hireBar and
 * ScoreChip prefers that. Score colours never use a constant.
 */
const HireBarContext = createContext(null);

export function HireBarProvider({ value, children }) {
  return <HireBarContext.Provider value={value}>{children}</HireBarContext.Provider>;
}

export function useHireBar() {
  return useContext(HireBarContext);
}

/** 0–100 score, whole number like the report (68.5 → "69"); null → "—". */
export const fmtScore = (v) => (v == null || Number.isNaN(Number(v)) ? '—' : String(Math.floor(Number(v) + 0.5)));

/** "pass" at or above the bar, "below" under it. */
export const scoreTone = (value, hireBar) => (Number(value) >= Number(hireBar) ? 'pass' : 'below');
